import * as React from 'react';
import Tooltip from '../tooltip/Tooltip';

export interface MetricCardProps {
  title: string;
  value: number | string;
  prefix?: string;
  suffix?: string;
  loading?: boolean;
  subLabel?: React.ReactNode;
  tooltip?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  prefix = '',
  suffix = '',
  loading = false,
  subLabel,
  tooltip,
}) => {
  const getDisplayValue = () => {
    if (value == null) {
      return '-';
    }
    if (typeof value === 'number') {
      return Math.round(value).toLocaleString('en-US');
    }
    if (typeof value === 'string') {
      const numericValue = parseFloat(value);
      if (!isNaN(numericValue)) {
        return Math.round(numericValue).toLocaleString('en-US');
      }
    }
    return String(value);
  };
  const displayValue = getDisplayValue();
  const cardClassName = subLabel ? 'metric-card metric-card--with-sublabel' : 'metric-card';

  const cardContent = (
    <div className={cardClassName}>
      {loading ? (
        <>
          <div className="metric-card__skeleton metric-card__skeleton--title"></div>
          <div className="metric-card__skeleton metric-card__skeleton--value"></div>
        </>
      ) : (
        <>
          <div className="metric-card__title">{title}</div>
          <div className="metric-card__value">
            {prefix}
            {displayValue}
            {suffix}
          </div>
          {subLabel && <div className="metric-card__sublabel">{subLabel}</div>}
        </>
      )}
    </div>
  );

  return tooltip ? (
    <Tooltip tooltipText={tooltip} className="metric-card__tooltip">
      {cardContent}
    </Tooltip>
  ) : (
    cardContent
  );
};
